import React from "react";
import useExerciseDetails from "../../hooks/useExerciseDetails";
import ExerciseInfo from "../../exerciseInfo";
import { Exercise } from "../../../../models/Exercise";
import "./SingleExerciseDetailsModal.scss";
import ModalComponent from "../../../../../features/ModalComponent";

interface IProps {
  exercise: Exercise;
  onClose: () => void;
  ticketsListLength: number;
  handleModals: (value: string) => void;
  onRefreshExercises: () => void;
}

const SingleExerciseDetailsModal: React.FC<IProps> = ({
  exercise,
  onClose,
  ticketsListLength,
  handleModals,
  onRefreshExercises,
}) => {
  const { exerciseDetails, handleJoinToExercise, alerts, handleLeaveFromExercise, joinErrorData, showLoginButton } =
    useExerciseDetails(exercise, onRefreshExercises);

  return (
    <div className="schedule-modal-info">
      <ModalComponent
        footer={false}
        open
        leftType="exercise"
        leftTitle={`${exerciseDetails.zone.displayName}`}
        leftImage={`${exerciseDetails.eventMessage}`}
        closeModal={onClose}
        title={exerciseDetails.name}
        onAccept={() => {}}
      >
        <ExerciseInfo
          handleModals={handleModals}
          joinToExercise={handleJoinToExercise}
          exercise={exerciseDetails}
          alerts={alerts}
          assignedStatus={exerciseDetails.assigned}
          waitList={exerciseDetails.waitList}
          ticketsListLength={ticketsListLength}
          leaveFromExercise={handleLeaveFromExercise}
          joinErrorData={joinErrorData}
          showLoginButton={showLoginButton}
        />
      </ModalComponent>
    </div>
  );
};

export default SingleExerciseDetailsModal;
